module.exports = __webpack_public_path__ + "static/media/mae-mu-rgRbqFweGF0-unsplash.2817dbac.jpg";